import {
  SCHEDULE_AVAILABILITY_BLOCKED_FILL,
  SCHEDULE_AVAILABILITY_BLOCKED_STRIPE,
  SCHEDULE_AVAILABILITY_BLOCKED_TEXT,
  SCHEDULE_AVAILABILITY_BOOKED_LESSON,
  SCHEDULE_AVAILABILITY_OPEN_TIME_BORDER,
  SCHEDULE_AVAILABILITY_OUTSIDE_HOURS,
} from 'pages/pga-coach/bookings/schedule/calendar/schedule-availability-styles'

export const GOOGLE_SYNCED_BLOCK_ID = '0'

export const isGoogleSyncedBlock = block =>
  String(block?.id) === GOOGLE_SYNCED_BLOCK_ID

export const SYNCED_BLOCK_TOOLTIP =
  'Synced from your connected calendar. This time is not editable here.'

const BOOKABLE_BORDER = '#D0D0D0'
const BLOCKED_BORDER = 'rgba(176, 184, 193, 0.45)'

export const AVAILABILITY_BLOCK_COLORS = {
  recurring: {
    backgroundColor: SCHEDULE_AVAILABILITY_BOOKED_LESSON,
    color: '#001C57',
    border: SCHEDULE_AVAILABILITY_OPEN_TIME_BORDER,
  },
  override: {
    backgroundColor: SCHEDULE_AVAILABILITY_BOOKED_LESSON,
    color: '#001C57',
    border: SCHEDULE_AVAILABILITY_OPEN_TIME_BORDER,
  },
  unavailable: {
    backgroundColor: SCHEDULE_AVAILABILITY_OUTSIDE_HOURS,
    color: SCHEDULE_AVAILABILITY_BLOCKED_TEXT,
    border: BOOKABLE_BORDER,
  },
  blocked: {
    backgroundColor: SCHEDULE_AVAILABILITY_BLOCKED_FILL,
    color: SCHEDULE_AVAILABILITY_BLOCKED_TEXT,
    border: BLOCKED_BORDER,
  },
  synced: {
    backgroundColor: SCHEDULE_AVAILABILITY_BLOCKED_FILL,
    color: SCHEDULE_AVAILABILITY_BLOCKED_TEXT,
    border: BLOCKED_BORDER,
  },
  outside: {
    backgroundColor: SCHEDULE_AVAILABILITY_OUTSIDE_HOURS,
    border: BOOKABLE_BORDER,
  },
}

const stripedFill = ({ backgroundColor, color, border }) => ({
  backgroundColor,
  color,
  backgroundImage: SCHEDULE_AVAILABILITY_BLOCKED_STRIPE,
  border: `1px solid ${border}`,
  boxShadow: 'none',
})

export const availabilityFill = variant => {
  const colors = AVAILABILITY_BLOCK_COLORS[variant]

  if (variant === 'blocked' || variant === 'synced') {
    return stripedFill(colors)
  }

  return {
    backgroundColor: colors.backgroundColor,
    color: colors.color,
    boxShadow: `inset 0 0 0 1px ${colors.border}`,
  }
}

export const availabilityDot = variant => {
  const colors = AVAILABILITY_BLOCK_COLORS[variant]

  if (variant === 'blocked' || variant === 'synced') {
    return {
      backgroundColor: colors.backgroundColor,
      backgroundImage: SCHEDULE_AVAILABILITY_BLOCKED_STRIPE,
      boxShadow: `inset 0 0 0 1px ${colors.border}`,
    }
  }

  return {
    backgroundColor: colors.backgroundColor,
    boxShadow: `inset 0 0 0 1px ${colors.border}`,
  }
}
